import { render } from "./Courses.vue?vue&type=template&id=403cbc0b&scoped=true&ts=true"
import script from "./Courses.vue?vue&type=script&lang=ts"
export * from "./Courses.vue?vue&type=script&lang=ts"

import "./Courses.vue?vue&type=style&index=0&id=403cbc0b&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403cbc0b"]])

export default __exports__